module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/baskerville_light_italic-091aa18a9e31123ec88548775195d2ea.woff";